var _defs, _rect, _rect2, _rect3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFalkonSmsBirdLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "falkon-sms-bird-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.111,
    height: 37.904,
    viewBox: "0 0 54.111 37.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffad00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff9400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ff8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_769",
    "data-name": "Rectangle 769",
    width: 9.875,
    height: 3.703,
    rx: 1.852,
    transform: "translate(5.057 23.162)",
    fill: "#1450ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_770",
    "data-name": "Rectangle 770",
    width: 9.875,
    height: 3.703,
    rx: 1.852,
    transform: "translate(5.05 2.627)",
    fill: "#1450ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_771",
    "data-name": "Rectangle 771",
    width: 9.875,
    height: 3.703,
    rx: 1.852,
    transform: "translate(0 12.829)",
    fill: "url(#linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M1175.649,386.583c-4.723-1.253-7.624,1.1-12.149,2.021l7.958,7.958a3.805,3.805,0,0,1,1.061,1.9c.051-.165.1-.317.148-.455,3.231-9.1,9.073-6.2,9.073-6.2A8.532,8.532,0,0,0,1175.649,386.583Z",
    transform: "translate(-1127.629 -380.041)",
    fill: "url(#linear-gradient-2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M475.226,203.587l16.023,15.225a3.16,3.16,0,0,1,.115,4.464l-16.283,17.135a.674.674,0,0,1-1.162-.445l-.185-7.3L460,219.61a3.157,3.157,0,0,1-.115-4.464L470.762,203.7A3.157,3.157,0,0,1,475.226,203.587Zm3.527,21.495a2.17,2.17,0,1,0-.675-1.519A2.17,2.17,0,0,0,478.754,225.082Zm-4.723-4.488a2.173,2.173,0,1,0-.078-3.069A2.173,2.173,0,0,0,474.03,220.594Zm-4.723-4.488a2.173,2.173,0,1,0-.077-3.073A2.173,2.173,0,0,0,469.307,216.106Z",
    transform: "translate(-446.882 -202.718)",
    fill: "#1450ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonSmsBirdLogo);
export default __webpack_public_path__ + "static/media/falkon-sms-bird-logo.13c9e3bd34a17642995ea6750f5c254e.svg";
export { ForwardRef as ReactComponent };